/** Numeric-only InputNumber helpers for smart defaults form. */

const ALLOWED_CONTROL_KEYS = new Set([
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Home',
    'End',
]);

const isShortcutKey = (event) => event.ctrlKey || event.metaKey || event.altKey;

const blockNonIntegerKeys = (event) => {
    if (isShortcutKey(event)) return;
    if (ALLOWED_CONTROL_KEYS.has(event.key)) return;
    if (/^\d$/.test(event.key)) return;
    event.preventDefault();
};

const blockNonDecimalKeys = (event) => {
    if (isShortcutKey(event)) return;
    if (ALLOWED_CONTROL_KEYS.has(event.key)) return;
    if (/^\d$/.test(event.key)) return;
    if (event.key === '.') {
        if (event.currentTarget?.value?.includes('.')) {
            event.preventDefault();
        }
        return;
    }
    event.preventDefault();
};

const blockNonIntegerBeforeInput = (event) => {
    const data = event.data;
    if (!data || isShortcutKey(event)) return;
    if (/\D/.test(data)) {
        event.preventDefault();
    }
};

const blockNonDecimalBeforeInput = (event) => {
    const data = event.data;
    if (!data || isShortcutKey(event)) return;
    if (/[^\d.]/.test(data)) {
        event.preventDefault();
        return;
    }
    if (data.includes('.') && event.currentTarget?.value?.includes('.')) {
        event.preventDefault();
    }
};

const blockIntegerPaste = (event) => {
    const pasted = event.clipboardData?.getData('text') ?? '';
    if (/[^\d]/.test(pasted)) {
        event.preventDefault();
    }
};

const blockDecimalPaste = (event) => {
    const pasted = event.clipboardData?.getData('text') ?? '';
    if (/[^\d.]/.test(pasted)) {
        event.preventDefault();
    }
};

export const parseIntegerInput = (value) => {
    if (value == null || value === '') return '';
    return String(value).replace(/\D/g, '');
};

export const parseDecimalInput = (value) => {
    if (value == null || value === '') return '';
    const cleaned = String(value).replace(/[^\d.]/g, '');
    const [whole, ...fractionParts] = cleaned.split('.');
    if (fractionParts.length === 0) return whole;
    return `${whole}.${fractionParts.join('')}`;
};

export const INTEGER_NUMBER_INPUT_PROPS = {
    parser: parseIntegerInput,
    formatter: (value) => (value == null || value === '' ? '' : String(value)),
    onKeyDown: blockNonIntegerKeys,
    onBeforeInput: blockNonIntegerBeforeInput,
    onPaste: blockIntegerPaste,
    inputMode: 'numeric',
    controls: false,
};

export const DECIMAL_NUMBER_INPUT_PROPS = {
    parser: parseDecimalInput,
    formatter: (value) => (value == null || value === '' ? '' : String(value)),
    onKeyDown: blockNonDecimalKeys,
    onBeforeInput: blockNonDecimalBeforeInput,
    onPaste: blockDecimalPaste,
    inputMode: 'decimal',
    controls: false,
    step: 0.25,
};
